import { Route } from '@angular/router';
import { SurveyComponent } from './survey.component';

export const surveyJsRoutes: Route[] = [
  { path: '', component: SurveyComponent },


];
